export const EMBED_MESSAGE_TYPES = {
  SESSION_ID: 'SESSION_ID',
  SUCCESS: 'SUCCESS',
  SUCCESS_WITH_REDIRECT: 'SUCCESS_WITH_REDIRECT',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED',
  MISSING_CHECKOUT_SESSION: 'MISSING_CHECKOUT_SESSION'
};